import axios from "axios";
import { notification } from "antd";

// A status-0 axios failure means the request never reached the server, so the
// endpoint is irrelevant -- one dropped connection fails every request in
// flight. Tell the user once instead of once per request.
//
// Reports and bulk uploads are the exception: they opt into a long timeout and
// already treat a dropped connection as success ("the report will be sent
// shortly"), so they must not raise this notice.
const LONG_RUNNING_TIMEOUT_MS = 60000;
const NOTICE_KEY = "network-connection-lost";

let noticeOpen = false;

// Chrome reports a timeout from its own network stack as "timeout of 0ms
// exceeded" when the request set no timeout.
const CONNECTIVITY_MESSAGES = ["Network Error", "timeout of 0ms exceeded"];

const isConnectivityFailure = (error: any): boolean =>
  CONNECTIVITY_MESSAGES.includes(error?.message) &&
  error?.response === undefined &&
  (error?.config?.timeout ?? 0) < LONG_RUNNING_TIMEOUT_MS;

export const initNetworkNotice = () => {
  axios.interceptors.response.use(
    (response) => {
      noticeOpen = false;
      return response;
    },
    (error) => {
      if (isConnectivityFailure(error) && !noticeOpen) {
        noticeOpen = true;
        console.log(
          "[network] no response from",
          error?.config?.url ?? "unknown url",
          "-- client connectivity problem, not a server error"
        );
        notification.warning({
          key: NOTICE_KEY,
          message: "Internet connection issues",
          description: "Please check your internet and refresh this page.",
          duration: 0,
          onClose: () => {
            noticeOpen = false;
          },
        });
      }
      return Promise.reject(error);
    }
  );
};
